module.exports = __webpack_public_path__ + "img/bank1-bg.f6fcfdae.png";